export enum NotAffectToOtherControls {
  None = 0,
  NotAffectToAll = 1,
  NotAffectToPosition = 2,
}
